import React from 'react';
import propTypes from 'prop-types';

const StarList = props => {

    const {starLevel} = props;

    return (
        <ul className={`star-list star-level-${starLevel}`}>
            <li className="star-item"></li>
            <li className="star-item"></li>
            <li className="star-item"></li>
            <li className="star-item"></li>
            <li className="star-item"></li>
            <li className="star-item"></li>
            <li className="star-item"></li>
            <li className="star-item"></li>
            <li className="star-item"></li>
            <li className="star-item"></li>
        </ul>
    )

};

StarList.propTypes = {
    starLevel: propTypes.number.isRequired
};

export default StarList;



// WEBPACK FOOTER //
// src/client/components/dashboardNew/objects/StarList.js